<template>

    <q-card-section class="q-pb-xs text-center">Chauffeur</q-card-section>
    <q-separator />

    <q-card-section class="text-center" v-if=" ! isClient"><!-- ne pas afficher le nom du chauffeur au client... -->
        <q-item-label>{{ driver.name }}</q-item-label>
    </q-card-section>

    <q-card-section class="text-center">

        <q-item-label v-if="driver.email && ! isClient">
            <q-btn icon-right="send" :label="driver.email" outline square no-caps class="full-width q-mb-sm"
                    @click="link('mailto:'+driver.email)" />
        </q-item-label>

        <q-item-label v-if="driver.phone">
            <q-btn icon-right="phone" :label="driver.phone" outline square no-caps
                    @click="link('tel:'+driver.phone)" />
        </q-item-label>

        <q-item-label v-if="driver.address">{{ driver.address }}</q-item-label>
    </q-card-section>

    <q-separator />
    <q-card-actions align="center" v-if="isCarrier">
        <q-btn icon="visibility" @click="link(route('users.edit', driver.id))" dense square outline color="info" />
    </q-card-actions>
        
</template>

<script setup>
import { link,/* hasRole, formatDate, open, nl2br , clickForDownload, rolesToString */ } from "@helpers";
// import { ref, computed } from "@vue/reactivity";
// import { userStore } from "@stores";

const props = defineProps({
    driver: Object,
})

</script>
